import withCheckoutContext from '@/withCheckoutContext';
import { PrimeDaysPill } from '@/components/FlightSummaryMeta/components/FlightSummaryMetaFooter/FlightSummaryMetaFooter';

export default withCheckoutContext(PrimeDaysPill);
